module.exports = __webpack_public_path__ + "img/IMG_20191125_200516.8e6ab170.jpg";